import React, { memo } from 'react';
import classnames from 'classnames';
import Element from '../../element';

interface IProps {
    className?: string;
    children: React.ReactNode;
    boxed?: string;
    right?: boolean;
}

function NavbarDropdown(props: IProps) {
    const { children, className, boxed, right } = props;

    return (
        <Element
            {...props}
            className={classnames('navbar-dropdown', className, {
                'is-boxed': boxed,
                'is-right': right,
            })}
        >
            {children}
        </Element>
    );
}

export default memo(NavbarDropdown);
